import { gql, TypedDocumentNode } from "@apollo/client";

import {
  RelatedCasesOptions,
  RelatedCasesQuery,
  RelatedCasesQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { caseFragment } from "src/graphql/anti-fraud/fragments/CaseFragment";
import { pageInfoFragment } from "src/graphql/anti-fraud/fragments/PageInfoFragment";
import { useFetchQuery } from "src/graphql/utils";
import { mapToCase } from "src/mappers/case.mappers";
import { isEmpty } from "src/utils/arrays.utils.ts";

export const getRelatedCases = gql`
  query RelatedCases($caseId: ID!, $options: RelatedCasesOptions!) {
    relatedCases(caseId: $caseId, options: $options) {
      cases {
        ...CaseFragment
      }
      pageInfo {
        ...PageInfo
      }
    }
  }

  ${caseFragment}
  ${pageInfoFragment}
` as TypedDocumentNode<RelatedCasesQuery, RelatedCasesQueryVariables>;

const useGetRelatedCases = (
  variables: { caseId: string; options: RelatedCasesOptions },
  options?: { skip: boolean | undefined }
) => {
  return useFetchQuery(getRelatedCases, {
    isEmpty: (data) => isEmpty(data?.relatedCases?.cases),
    toData: (data) =>
      data
        ? {
            cases: data.relatedCases.cases.map(mapToCase),
            pageInfo: data.relatedCases.pageInfo,
          }
        : null,
    uiErrors: {
      fetchError: "FETCH-RELATED-CASES-ERROR",
    },
    queryOptions: {
      variables: variables,
      skip: options?.skip,
      fetchPolicy: "no-cache",
    },
  });
};

export default useGetRelatedCases;
